<script setup lang="ts">
defineProps({
	rows: {
		type: String,
		default: '10',
	},
	isInviteDashboard: {
		type: Boolean,
		default: false,
	},
});
</script>

<template>
	<MultipleSkeletonLoader
		class="contact-container-loader"
		space="0"
		:rows="rows"
		has-divider
	>
		<tr :class="['contact-item-loader', { '--invite-dashboard': isInviteDashboard }]">
			<td :class="['contact-info-loader', { '--invite-dashboard': isInviteDashboard }]">
				<ButtonSkeletonLoader
					v-if="isInviteDashboard"
					class="contact-checkbox"
					width="20"
					height="20"
				/>
				<VSkeletonLoader
					type="avatar"
					width="40"
					height="40"
				/>
				<VSkeletonLoader
					class="contact-paragraph"
					type="list-item-two-line"
				/>
			</td>
			<td>
				<BadgeSkeletonLoader
					v-if="isInviteDashboard"
					class="contact-status"
					width="60"
				/>
				<ButtonSkeletonLoader
					v-else
					class="delete-btn"
					width="40"
				/>
			</td>
		</tr>
	</MultipleSkeletonLoader>
</template>

<style scoped lang="scss">
.contact-container-loader {
	.contact-item-loader {
		display: grid;
		grid-template-columns: minmax(auto, 1fr) rem(40);
		align-items: center;

		&.--invite-dashboard {
			grid-template-columns: 1fr 1fr;
		}

		.contact-checkbox {
			:deep(.v-skeleton-loader__button) {
				border-radius: rem(4) !important;
			}
		}

		.delete-btn {
			margin: auto;
			width: 100%;
		}

		.contact-status {
			display: flex;
			margin: 0 auto;
		}
	}

	.contact-info-loader {
		display: grid;
		grid-template-columns: rem(40) minmax(auto, 1fr);
		align-items: center;
		padding: spacings-get(4) 0;

		&.--invite-dashboard {
			grid-template-columns: rem(20) rem(40) minmax(auto, 1fr);
			gap: spacings-get(3);
		}

		:deep(.v-skeleton-loader__avatar) {
			width: spacings-get(10);
			height: spacings-get(10);
			min-width: spacings-get(10);
			min-height: spacings-get(10);
			margin: 0;
		}

		:deep(.v-skeleton-loader__text:first-child) {
			margin-bottom: spacings-get(4);
		}

		:deep(.v-skeleton-loader__text) {
			margin-left: 0;
		}

		.contact-paragraph {
			width: rem(200);
		}
	}
}
</style>
